
import ViewBase from '../../../view-base.view';
import { messageComponent } from '../../../../components/message/message.component';
import { Dialog } from 'construct-ui';
import loginModel from '../../../../models/login.model';
import DatePickerComponent from '../../../../components/date-picker/date-picker.component';
import taskTemplateModel from '../../../../models/task-management/task-template.model';
import UserAttributeListComponent from '../../../../components/common/user-attribute-list-select.component';
import TaskTemplateTaskListView from './task-template-task-list.view';
import moment from 'moment';
import { formats as FORMATS } from '../../../../config/constants';
import TaskTemplateUserSearchComponent from './task-template-user-selection-view';

export default function TaskTemplateAddView() {
  ViewBase.call(this);

  let onAddClose = (e) => { }
  let onSaveComplete = (e) => { }

  let showDatePicker = false;
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let fromInitDate;
  let toInitDate;
  let isTaskListOpen = false;
  let userSelectionViewOpen = false;
  let _selecteduserCount = "";
  let _isBCPOptionEditable = false;
  let inputDataModel = {
    canEdit: true,
    templateName: "",
    description: "",
    masterId: 0,
    permission: "",
    isBcpTemplate: false,
    startDate: "",
    endDate: "",
    selectedTaskList: [],
    assignedTaskList: [],
    assignedOriginalTaskList: [],
    alluserList: [],
    totalCount: 0,
    pageIndex: 1,
    pageSize: 10,
    userCriteria: {
      selectedUsers: [],
      selectedUserRoles: [],
      selectedSites: [],
      selectedSiteGroups: []
    }
  };

  let _getTemplateName = (e) => {
    inputDataModel.templateName = e.target.value;
  }

  let _getDescription = (e, val) => {
    inputDataModel.description = e.target.value;
  }

  let _onDatePickerChange = (e) => {
    fromInitDate = moment(e.detail.start).format(FORMATS.dateFormat);
    toInitDate = moment(e.detail.end).format(FORMATS.dateFormat);
    inputDataModel.startDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
    inputDataModel.endDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
  }

  let _getTaskListWithSequence = (id) => {
    let items = document.querySelectorAll('#' + id + '> li');
    let seq = 1;
    let dtValues = [];
    items.forEach(item => {
      let inputList = item.querySelectorAll('input')
      let radioValues = { taskMstId: "", seq: "", mandatoryYN: "" };
      let txtId = inputList[1].value;
      let mandatory = inputList[2].checked;
      radioValues["taskMstId"] = txtId;
      radioValues["seq"] = seq.toString();
      radioValues["mandatoryYN"] = mandatory ? "Y" : "N";
      dtValues.push(radioValues);
      seq++;
    });
    return dtValues;
  }

  let _save = () => {
    let dataModel = {
      taskTemplateMstId: "0",
      taskTemplateName: inputDataModel.templateName,
      description: inputDataModel.description,
      permission: inputDataModel.permission,
      startDate: inputDataModel.startDate,
      endDate: inputDataModel.endDate,
      taskAssigned: [],
      userRoleCodes: "",
      siteGroupIds: "",
      siteIDs: "",
      userIDs: "",
      isBCPTemplate: inputDataModel.isBcpTemplate
    };

    dataModel.taskAssigned = _getTaskListWithSequence("tastListId");
    dataModel.userRoleCodes = inputDataModel.userCriteria["selectedUserRoles"]?.map(r => r.code).join('^');
    dataModel.siteGroupIds = inputDataModel.userCriteria["selectedSiteGroups"]?.map(sg => sg.code).join('^');
    dataModel.siteIDs = inputDataModel.userCriteria["selectedSites"]?.map(s => s.siteId).join('^');
    dataModel.userIDs = inputDataModel.userCriteria["selectedUsers"]?.map(u => u.userID).join('^');
    dataModel.taskTemplateMstId = inputDataModel.masterId;

    if (dataModel.taskTemplateMstId > 0) {
      taskTemplateModel.editTaskTemplate(dataModel)
        .then((result) => {
          if (result[0].transStatus == "SUCCESS") {
            onSaveComplete(result);
          }
        })
        .catch((error) => {
          this.handleError(error);
        });
    } else {
      taskTemplateModel.saveTaskTemplate(dataModel)
        .then((result) => {
          if (result[0].transStatus == "SUCCESS") {
            onSaveComplete(result);
          }
        })
        .catch((error) => {
          this.handleError(error);
        });
    }

  }

  let _cancel = (e) => {
    onAddClose(e);
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let _arrangeInputDataModel = (result) => {
    inputDataModel.templateName = result.taskResult[0]["taskTemplateName"];
    inputDataModel.isBcpTemplate = result.taskResult[0]["isBCPTemplate"];
    inputDataModel.description = result.taskResult[0]["description"];
    inputDataModel.permission = result.taskResult[0]["permission"];
    inputDataModel.startDate = result.taskResult[0]["startDate"];
    inputDataModel.endDate = result.taskResult[0]["endDate"];
    if (inputDataModel.startDate && inputDataModel.endDate && inputDataModel.startDate != "" && inputDataModel.endDate != "") {
      fromInitDate = moment(inputDataModel.startDate).format(FORMATS.dateFormat);
      toInitDate = moment(inputDataModel.endDate).format(FORMATS.dateFormat);
    }
    else {
      fromInitDate = moment(new Date()).format(FORMATS.dateFormat);
      toInitDate = moment(new Date()).format(FORMATS.dateFormat);
    }
    showDatePicker = true;
    inputDataModel.assignedTaskList = [];
    let tasks = [];
    inputDataModel.assignedOriginalTaskList = [];
    if (result.taskAssignedResult && result.taskAssignedResult.length > 0) {
      result.taskAssignedResult.sort((a, b) => a.seq - b.seq);
      result.taskAssignedResult.forEach(function (item) {
        tasks.push({ name: item.taskName, id: item.taskMstID.toString(), mandatory: item.mandatoryYN });
        inputDataModel.assignedOriginalTaskList.push({ text: item.taskName, value: item.taskMstID.toString() });
      });
      inputDataModel.assignedTaskList = tasks;
    }
    inputDataModel.userCriteria.selectedUserRoles = result.mapTypeResult.filter(x => x.mapType == "UserRole").map((u) => ({ code: u.id, name: u.name }));
    inputDataModel.userCriteria.selectedUsers = result.mapTypeResult.filter(x => x.mapType == "UserId").map(u => ({ userID: u.id, userName: u.name }));
    inputDataModel.userCriteria.selectedSiteGroups = result.mapTypeResult.filter(x => x.mapType == "SiteGroup").map((u) => ({ code: u.id, name: u.name }));
    inputDataModel.userCriteria.selectedSites = result.mapTypeResult.filter(x => x.mapType == "Site").map((u) => ({ siteId: u.id, siteName: u.name }));


    if (inputDataModel.userCriteria.selectedUserRoles.length !== 0 || inputDataModel.userCriteria.selectedUsers.length !== 0 ||
      inputDataModel.userCriteria.selectedSites.length !== 0 || inputDataModel.userCriteria.selectedSiteGroups.length !== 0) {
      _selecteduserCount = this.getText("LT00000121", "Assigned")
    } else {
      _selecteduserCount = "";
    }
  }

  let _loadDataForId = (userID) => {
    return taskTemplateModel.getTemplateDetailById(inputDataModel.masterId)
      .then((result) => {
        _arrangeInputDataModel(result, userID);
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let _loadTaskSelection = () => {
    isTaskListOpen = true;
  }

  let _onAttributeSave = (selectedList) => {
    let alrAssignList = inputDataModel.assignedTaskList;
    inputDataModel.assignedTaskList = [];
    selectedList.forEach(function (item) {
      let mandatoryYN = "Y";
      let existsObj = alrAssignList.filter(x => x.id == item.value);
      mandatoryYN = existsObj.length == 1 ? existsObj[0].mandatory : "Y";
      inputDataModel.assignedTaskList.push({ name: item.text, id: item.value, mandatory: mandatoryYN });
    });
    inputDataModel.assignedOriginalTaskList = selectedList;
    isTaskListOpen = false;
  }

  let _onAttributeClose = () => {
    isTaskListOpen = false;
  }

  let _loadUserSelection = () => {
    userSelectionViewOpen = true;
  }

  let _onUserSearchChanged = (inputSearchObj) => {
    inputDataModel.userCriteria = inputSearchObj;
    if (inputDataModel.userCriteria.userRoleText != "" || inputDataModel.userCriteria.siteGroupText != "" || inputDataModel.userCriteria.siteText != "" ||
      inputDataModel.userCriteria.userText != "") {
      _selecteduserCount = this.getText("LT00000121", "Assigned");
    } else {
      _selecteduserCount = "";
    }

    userSelectionViewOpen = false;
  }

  let _taskListChanged = (taskList) => {
    inputDataModel.assignedTaskList = taskList;
    inputDataModel.assignedOriginalTaskList = [];
    taskList.forEach((task) => {
      inputDataModel.assignedOriginalTaskList.push({ value: task.id, text: task.name });
    });
  }

  let _onRemoved = (item) => {
    inputDataModel.assignedTaskList = inputDataModel.assignedTaskList.filter(x => x.id != item.id);
    inputDataModel.assignedOriginalTaskList = inputDataModel.assignedOriginalTaskList.filter(x => x.value != item.id);
  }

  let _newTask = () => {
    localStorage.setItem("template", JSON.stringify(inputDataModel));
    m.route.set("/task-master?ref=task-template");
  }

  let getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }


  let getTaskTemplateBCPOptions = () => {
    taskTemplateModel.getTemplateBCPOptions()
      .then((r) => {
        if (r && Array.isArray(r) && r.length > 0) {
          _isBCPOptionEditable = true;
        }
      }).catch(e => {
        this.handleError(e);
      })
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onAddClose) {
        onAddClose = vnode.attrs.onAddClose;
      }
      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }
      getTaskTemplateBCPOptions();
      let ref = getParameterByName("ref");
      if (ref == "task-master") {
        inputDataModel = JSON.parse(localStorage.getItem("template"));
        fromInitDate = moment(inputDataModel.startDate).format(FORMATS.dateFormat);
        toInitDate = moment(inputDataModel.endDate).format(FORMATS.dateFormat);
        showDatePicker = true;
        localStorage.removeItem("template");
        window.location = "#!/task-template";
      } else {
        if (vnode.attrs.masterId) {
          inputDataModel.masterId = vnode.attrs.masterId;
          if (inputDataModel.masterId > 0) {
            _loadDataForId(vnode.attrs.userID);
          } else {
            fromInitDate = moment(new Date()).format(FORMATS.dateFormat);
            toInitDate = moment(new Date()).format(FORMATS.dateFormat);
            showDatePicker = true;
          }
        }
        else {
          showDatePicker = true;
        }
        if (loginModel.credentials.admin) {
          inputDataModel.canEdit = true;
        } else if (vnode.attrs.userID == 0) {
          inputDataModel.canEdit = true;
        } else {
          if (loginModel.credentials.userID == vnode.attrs.userID) {
            inputDataModel.canEdit = true;
          } else {
            inputDataModel.canEdit = false;
          }
        }
      }

      inputDataModel.statusList = [{ code: "", name: "Choose..." }, { code: "001", name: "Active" }, { code: "002", name: "Inactive" }];
    },
    view: (vnode) => {
      return [
        m('.card',
          m('.card-body',
            m('.row',
              m('.col-md-12', m('label.form-label', this.getText("LT00000078", "Task Name"), m('span.redText', "*")), m('input[type=text][placeholder=' + this.getText("LT00000078", "Task Name") + '][value="' + inputDataModel.templateName + '"].form-control.form-control-bg', { disabled: !inputDataModel.canEdit, onchange: _getTemplateName }
              )),
              _isBCPOptionEditable &&
              m(".col-md-10.mt-1", m(".form-check", [
                m("input.form-check-input[type=checkbox]", { checked: inputDataModel.isBcpTemplate, onchange: (e) => { inputDataModel.isBcpTemplate = !inputDataModel.isBcpTemplate } }),
                m("label.form-check-label", "BCP Template")
              ])
              ),
              m('.col-md-12.mt-3', m('label.form-label', this.getText("LT00000012", "Description"), m('span.redText', "*")), m('textarea[id="txtContent"][placeholder=' + this.getText("LT00000012", "Description") + '].form-control.form-control-bg', { disabled: !inputDataModel.canEdit, onchange: _getDescription }, inputDataModel.description
              ))),
            showDatePicker && m('.col-md-6.mt-3',
              m('label.form-label', this.getText("LT00000070", "Date Range")),
              m(DatePickerComponent, {
                class: 'form-control',
                isRange: true,
                dateStart: fromInitDate, // default date range
                dateEnd: toInitDate, // default date range
                onselect: (e) => {
                  _onDatePickerChange(e);
                }
              })
            ),
            m('.col-md-12.mt-3',
              m('.col-md-12', m('label', this.getText("LT00000079", "Permission"))),
              m('.row.mt-2',
                m('.col-md-6',
                  m('.form-check.form-check-inline',
                    m('input.form-check-input[type="radio"][name="radioType"]',
                      {
                        disabled: !loginModel.credentials.admin,
                        checked: inputDataModel.permission == "001",
                        onclick: (e) => {
                          inputDataModel.permission = "001"
                        }
                      }
                    ),
                    m('label.form-check-label', this.getText("LT00000083", "Public"))
                  )
                ),
                m('.col-md-6',
                  m('.form-check.form-check-inline',
                    m('input.form-check-input[type="radio"][name="radioType"]',
                      {
                        disabled: !inputDataModel.canEdit,
                        checked: inputDataModel.permission == "002",
                        onclick: (e) => {
                          inputDataModel.permission = "002"
                        }
                      }
                    ),
                    m('label.form-check-label', this.getText("LT00000084", "Personal"))
                  )
                ),
              ),
            ),
            m('.col-md-12.mt-3',
              m('.col-md-12', m('label', this.getText("LT00000110", "Tasks"), m('span.redText', "*"))),
              m('.d-flex.justify-content-between.mt-2',
                m('button.btn.btn-sm.btn-primary.me-2', { disabled: !inputDataModel.canEdit, onclick: _loadTaskSelection },
                  this.getText("LT00000109", "Please specify tasks")
                ),
                m('button.btn.btn-sm.btn-outline-primary',
                  { onclick: _newTask, disabled: !inputDataModel.canEdit },
                  m("i.bi bi-plus-lg.me-0")
                ),
              ),
            ),
            inputDataModel.assignedTaskList.length > 0 && m('.col-md-12.mt-3.p-2',
              m(TaskTemplateTaskListView, { taskList: inputDataModel.assignedTaskList, _onChanged: _taskListChanged, _onRemoved: _onRemoved, disabled: !inputDataModel.canEdit })
            ),
            m('.row.mt-3',
              m('.col-md-12',
                m('label.form-label', this.getText("LT00000119", "Assigned Users"),
                  m('span.redText', "*")),
              ),
              m('.col-md-12',
                m('button.btn.btn-primary', { onclick: _loadUserSelection },
                  _selecteduserCount != "" ? _selecteduserCount : this.getText("LT00000120", "Please specify users")
                )
              )
            )
          ),
          m('.card-footer',
            m('.col-md-12 .gap-2 .d-flex .justify-content-center',
              inputDataModel.canEdit && m(
                "button.btn.btn-primary[type='button']", { onclick: _save },
                this.getText("LT00000022", "Save")
              ),
              m(
                "button.btn.btn-white[type='button']", { onclick: _cancel },
                this.getText("LT00000021", "Close")
              )
            )
          )
        ),
        m(Dialog, {
          isOpen: isTaskListOpen,
          transitionDuration: 200,
          onClose: () => { isTaskListOpen = false; },
          title: this.getText("LT00000742", "Task List"),
          content: m(UserAttributeListComponent, { type: "005", masterId: "0", selectedAttribute: inputDataModel.assignedOriginalTaskList, onSave: _onAttributeSave, onAddClose: _onAttributeClose }),
          "class": "cui-dialog-l"
        }),
        m(Dialog, {
          isOpen: userSelectionViewOpen,
          transitionDuration: 200,
          onClose: () => { userSelectionViewOpen = false; },
          title: this.getText("LT00000061", "User Selection"),
          content: m(TaskTemplateUserSearchComponent, { onAddClose: () => { userSelectionViewOpen = false; }, enabledName: true, enabledUserRole: true, enabledControlPanel: true, onChanged: _onUserSearchChanged, searchCriteria: inputDataModel.userCriteria, disabled: !inputDataModel.canEdit }),
          // "class": "cui-dialog-xxl"
        }),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
        this.getBaseViews()
      ];
    }
  }
}
